//https://codepen.io/stefen/pen/wybOYy
var $ = require('jquery');

$(document).ready(function(){

	//Hubspot placeholder stuff
	window.addEventListener('message', event => {
		if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {

			var $input = $('.hs-form .hs-input');

			$input
				.on('focus', function() {
					$(this).addClass('active')
						.parent()
						.parent()
						.addClass('active');
				})
				.blur();

			$input
				.focusout(function() {
					if (!$(this).val()) {
						$(this)
							.parent()
							.parent()
							.removeClass('active');
					} else {
						$(this)
							.parent()
							.parent()
							.addClass('active');
					}
				})
				.focusout(); // focusout event for prefilled forms


		}
	});

	// Move hubspot form's disclaimer below submit button
	var checkFormLoaded = setInterval(function() {
		if ($('#hsForm_0977bb45-9cfe-483d-a96e-abb27ad9d014').length ||
			$('#hsForm_0cf8ab76-d161-418b-9057-a1e8803724f4').length ||
			$('#hsForm_4a55bdd0-4cdd-4d11-a199-ffa3b61fe8ef').length) {
			$('.hs-richtext:has(p:contains("Click here for Rapyd’s Privacy Policy for more details."))')
				.insertAfter('.hs_submit')
				.addClass('form-disclaimer');
			clearInterval(checkFormLoaded);
		}
	}, 100);

});
